var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.78,
    height: 93.36,
    viewBox: "0 0 116.78 93.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(-949.97 -1496.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479",
    transform: "translate(-2274.575 -2303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M3295.734,3870.555h-16.16l-16-27.555-2.933-.517v-7.021h35.093Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 13.16,
    height: 13.16,
    transform: "translate(3271.608 3835.462)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 35.093,
    height: 35.093,
    transform: "translate(3295.734 3835.462)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 13.16,
    height: 13.16,
    transform: "translate(3306.701 3835.462)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 35.093,
    height: 35.093,
    transform: "translate(3278.188 3800.37)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 13.16,
    height: 13.16,
    transform: "translate(3289.155 3800.37)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M3279.575,3870.555l13,21.445,8-4,4.42-4.286h19.983V3892h15.6v-21.445Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M3261.08,3822.71l-34.933,60.505a5.857,5.857,0,0,0,5.073,8.785h69.865a5.857,5.857,0,0,0,5.072-8.785l-34.933-60.505A5.856,5.856,0,0,0,3261.08,3822.71Z",
    fill: "aqua",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1139",
    "data-name": "Line 1139",
    y1: 39.481,
    transform: "translate(3266.152 3846.558)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M3261.223,3882.09l4.935-3.395,4.923,3.395",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M3271.081,3850.506l-4.935,3.395-4.923-3.395",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1140",
    "data-name": "Line 1140",
    y1: 20.199,
    x2: 33.922,
    transform: "translate(3249.191 3856.198)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M3250.062,3870.143l5.442,2.5-.4,5.966",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M3282.243,3862.453l-5.442-2.5.4-5.966",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1141",
    "data-name": "Line 1141",
    x2: 34.711,
    y2: 18.812,
    transform: "translate(3248.797 3856.892)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M3254.616,3854.44l.633,5.957-5.33,2.71",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M3277.688,3878.156l-.633-5.956,5.33-2.71",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoIcon);
export default __webpack_public_path__ + "static/media/cargo-icon.89d60bf3046997de90ee592cdde28736.svg";
export { ForwardRef as ReactComponent };